export default __webpack_public_path__ + "static/media/cloze-drag-drop-blue.afd6387d.svg";